import { request } from '@/shared/api/request'

export const dtspMioList = (params) => {
	return request({ url: `paryz/dtsp/mio/list`, method: 'get', params })
}

export const dtspReportList = (params) => {
	return request({ url: `paryz/dtsp/report/list`, method: 'get', params })
}

export const dtspReportSign = (data) => {
	return request({ url: `paryz/dtsp/report/sign`, method: 'post', data })
}

export const dtspReportXml = (data) => {
	return request({ url: `paryz/dtsp/report/xml`, method: 'post', data })
}

export const dtspReqsList = (data) => {
	return request({ url: `paryz/dtsp/reqs/list`, method: 'post', data })
}

export const dtspReqsOne = (externalId) => {
	return request({ url: `paryz/dtsp/reqs/one/${externalId}`, method: 'get' })
}

export const dtspReqsPage = ({data, params}) => {
	return request({ url: `paryz/dtsp/reqs/page`, method: 'post', params, data })
}